<template>

<div class="container card mb-5">
	<div class="card-body">

		<!---
		<div class="mb-5">
			<field
				:params="{
					type:'btn-group',
					buttons: [
						{text: 'Manage Categories', value:'manage-categories'},
						{text: 'Import Materials',  value:'upload-file'}
					],
					tabStyling:true,
					disableNull:true
				}"
				v-model="currentStage">
			</field>
		</div>

		--->


		<!--- Manage, Create, Delete Categories --->
		<div v-show="currentStage == 'manage-categories'">

			<div class="d-flex justify-content-between">

				<h2 class="mb-4">Create Material Categories</h2>

				<button
					v-on:click="resetImport"
					class="btn btn-primary mt-2"
					:disabled="!categories || !categories.length">

					Next
					<i class="fa fa-arrow-right"></i>
				</button>

			</div>

			<material-category-tree
				v-if="categories"
				v-model="categories"
			></material-category-tree>

		</div>


		<!--- Show a file template, then upload a file --->
		<div v-if="currentStage == 'upload-file'">

			<h2 class="mb-4">Import Materials</h2>

			<div class="mb-4">

				<h4>Fields</h4>

				<ul>
					<li v-for="field in requiredFields" class="mb-2">

						<span class="font-weight-bold" v-html="field.name"></span>
						<span v-if="'description' in field && field.description">
							 - &nbsp
							<span v-html="field.description"></span>
						</span>
					</li>
				</ul>

			</div>

			<div class="d-flex flex-row justify-content-between align-items-end">

				<h4>Example</h4>

				<button class="btn btn-primary btn-sm mb-3" v-on:click="downloadTemplate">
					<i class="fa fa-download"></i>
					Download Template
				</button>

			</div>

			<div style="overflow-x: auto;">
				<table class="spreadsheet-table w-100 mb-3">

					<tr>
						<th></th>
						<th v-for="(field, index) in requiredFields">
							{{numAsChar(index + 1)}}
						</th>
					</tr>

					<tr v-for="(row, index) in exampleCSV">
						<th>{{index + 1}}</th>
						<td v-for="field in row">{{field}}</td>
					</tr>

				</table>
			</div>

			<div class="d-flex justify-content-around card mb-3">

				<div class="card-body">

					<div class="d-flex justify-content-around align-items-baseline">
						<h3 class="card-title mt-2">Upload Materials CSV</h3>
						<input type="file" v-on:change="uploadFile">
					</div>

					<div v-if="isErrorAlertVisible" class="alert alert-danger mt-3 mb-0">
						File contains errors in one or more rows. <a href="#" v-on:click.prevent="downloadFileWithErrors">Click here</a>
						to download a copy of your file with more information.  Please fix these errors and re-upload your file before continuing.
					</div>
				</div>

			</div>

			<div class="d-flex justify-content-between">

				<button v-on:click="currentStage = 'manage-categories'" class="btn btn-primary">
					<i class="fa fa-arrow-left"></i>
					Back
				</button>

				<button v-on:click="validateFile" class="btn btn-primary" :disabled="!isFileHeadersValid">
					Next
					<i class="fa fa-arrow-right"></i>
				</button>

			</div>

		</div>


		<!--- Show any issues with missing categories in the file --->
		<div v-else-if="currentStage == 'categories-summary'">

			<h2 class="mb-4">Fix Missing Categories</h2>

			It looks like there are {{fixableMaterials.length}} material(s) that need fixing.
			To review and fix these materials, click the "Next" button. To restart, click "Back".

			<div class="d-flex justify-content-between mt-4">

				<button class="btn btn-primary mr-4" v-on:click="resetImport">
					<i class="fa fa-arrow-left"></i>
					Back
				</button>

				<button class="btn btn-primary" v-on:click="saveAndFetchNext">
					Next
					<i class="fa fa-arrow-right"></i>
				</button>

			</div>

		</div>


		<!--- Allow the user to fix any issues with the file --->
		<div v-else-if="currentStage == 'fix-file'">

			<h2 class="mb-4">Fix Missing Categories</h2>

			<table class="table">
				<tr>
					<th v-if="pulledFromCSV">Error</th>
					<th>Material Description</th>
					<th>Material Part Number</th>
					<th>New Category</th>
				</tr>
				<tr v-for="material in fixableMaterials">
					<td v-if="pulledFromCSV">{{material.error}}</td>
					<td>{{material.part_number}}</td>
					<td>{{material.description}}</td>
					<td>
						<material-category-select
							:reset-key="categoryKey"
							v-on:categorySelected="setCategory(material, $event)"
							:category-tree="categoryTree">
						</material-category-select>
					</td>
				</tr>
			</table>

			<div class="text-right">
				<button v-on:click="saveAndFetchNext" class="btn btn-primary" :disabled="!isAllMaterialsValid">
					Next
					<i class="fa fa-arrow-right"></i>
				</button>
			</div>

		</div>


		<!--- Now that the file is good, confirm the import --->
		<div v-else-if="currentStage == 'confirm-import'">

			<h2 class="mb-4">Finish Import</h2>

			<div>Everything looks good to go!</div>

			<button v-on:click="finishUpload" class="btn btn-primary mt-4">
				<i class="fa fa-check"></i>
				Finish
			</button>

		</div>

	</div>

</div>
</template>

<script>

import MaterialCategoryTree from "./MaterialCategoryTree";
import MaterialCategorySelect from "./MaterialCategorySelect";
import Field from "../Field";

export default {
	name: "MaterialImporter",
	props: [
	],
	components: {
		MaterialCategoryTree,
		MaterialCategorySelect,
		Field
	},

	data() {
		return {

			// 'manage-categories', 'upload-file', 'categories-summary', 'fix-file', 'confirm-import'
			currentStage: 'manage-categories',

			// Our list of material categories
			categories: null,

			// Update this to reset ALL selected material categories
			categoryKey: 0,

			allMaterials: [],	   	// Our list of material drafts
			fixableMaterials: [],	// A subset of allMaterials containing only materials with no category selected
			pulledFromCSV: true,		// Did we pull allMaterials from a CSV?  Or TradeTraks?

			errorColumnName: "Errors", // Name of the generated error column
			isErrorAlertVisible: false,  // Visible if the user tries to upload a file with erroneous rows (not category-related)

			// Which fields are required in the file?
			requiredFields: [
				{
					name: 'Category',
					description: 'Materials can only be added to categories containing other materials.' +
						' Categories containing subcategories cannot also contain materials.  To get a category' +
						' path go to the "Categories" tab and click the <i class="fa fa-copy mx-1"></i> icon' +
						' next to a valid category.'
				},
				{ name: 'Description',               description: 'The material name' },
				{ name: 'Part Number',               description: 'The material part number' },
				{ name: 'Supplier PN',               description: 'The material part number of the supplier' },
				{ name: 'Manufacturer',               description: 'The company that manufactures the material' },
				{ name: 'Date of Last Price Update', description: 'In the format "YYYY-MM-DD"'},
				{ name: 'Per Unit',                  description: 'A rounded number (ex. "1", "100", or "1000")'},
				{ name: 'Unit Type',                 description: '"each", "ft", "m", "yard", "oz", "lb", "ton", "g", "kg", "sq.ft.", "sq.m.", "sq.yd", "lt", or "usg"' },
				{ name: 'Material Price',            description: 'The material price' },
				{ name: 'Labour',                    description: 'The number of labour hours / unit'},
				{ name: 'Supplier ID',               description: 'The Tradetraks ID of the supplier contact.  Set to "0" if there is no associated supplier.'}

			],

			// Template.csv
			exampleCSV: [
				['Category', 'Description', 'Part Number','Supplier PN','Manufacturer', 'Date of Last Price Update', 'Per Unit', 'Unit Type', 'Material Price', 'Labour', 'Supplier ID'],
				['AGGREGATES\\\\Top Soil',                   '1/2" EMT Conduit',  'EMT-123', 'EMT123','ACME',    '2018-01-02', '100', 'ft',   '89.93', '0.750', '32482'],
				['WIRE\\\\RW90',                             'EMT Elbow',         'EMT 90 ELL','EMT 90 ELL','ACME', '2018-01-02', '100', 'm',    '56.12', '1.405', '0'],
				['DISTRIBUTION\\\\BREAKERS\\\\FPE BOLT ON ', '1/2" Conduit Body', 'CBLB50COM','CBLB50COM','ACME',  '2018-01-02', '1',   'each', '89.93', '0.050', '22394']
			],

			file: null,					// The file the user uploaded
			fileHeaders: null,		// Header row in the file
			fileRows: null,			// Main body of the file

			pathDelimiter: '\\\\'	// How should we separate the path? (ex. 'Cat1\\Cat2')

		}
	},

	computed: {

		isAllMaterialsValid() {
			return !(this.fixableMaterials.filter(m => m.is_draft == '1' || m.category_id == 0).length)
		},

		categoryTree() {
			/* Organize the category records in a tree structure */
			return this.groupRecords(this.categories, 'category_id')
		},

		headerIndices() {
			/*
			Returns a dictionary in format { csvHeader : arrayIndex }
			*/

			if (!this.fileHeaders)
				return false

			let indices = {}
			this.requiredFields.forEach(field => {
				indices[field.name] = this.fileHeaders.findIndex(f => f == field.name)
			})
			return indices
		},

		isFileHeadersValid() {
			/*
			Returns true if the file contains the required headers.
			Returns false otherwise.
			 */

			if (!this.headerIndices)
				return false

			let isValid = !Object.values(this.headerIndices).includes(-1)

			if (!isValid)
				this.alertFail("Invalid file format! File must contain the required headers.")

			return isValid
		}
	},

	methods: {

		finishUpload() {
			/*
			"Finish" the upload.  Redirect the user to the upload page,
			and display a message
			 */
			this.alertSaved("All Materials have been imported")
			this.resetImport()
		},

		saveAndFetchNext() {
			/*
			Save all materials to TradeTraks
			Note that in the previous stage, all invalid materials are marked with is_draft=1
			while all valid materials are marked with is_draft=0
			This is called when the user first begins the process, and each time a
			batch of materials is finished being fixed
			 */
			let vm = this


			this.saveMaterials(this.allMaterials).then(response => {
				if (response.success) {
					vm.fetchMaterialDrafts()
				}
			})
		},

		saveMaterials(materials) {
			/*
			Saves a list of materials. Returns a PROMISE
			 */
			let vm = this

			// We need to remove the 'error' key if any materials are invalid
			let temp = this.cloneObj(materials).map(m => {
				if ('error' in m)
					delete m.error
				return m
			})

			return this.postData('Material/save-batch', { records: temp },true)
		},

		setCategory(material, category) {
			/* Sets the category, updates record */
			material.category_id = category ? category.id : 0
			material.is_draft = category ? 0 : 1
		},

		resetImport() {
			/* Reset the fields relating to a file import */

			this.file = null
			this.fileHeaders = null
			this.fileRows = null
			this.allMaterials = []
			this.fixableMaterials = []
			this.isErrorAlertVisible = false
			this.currentStage = 'upload-file'
		},

		downloadFileWithErrors() {
			/* Downloads a copy of the uploaded file, with a new column for errors */

			let errorColumn = this.fileHeaders.findIndex(col => col == this.errorColumnName)

			let newCSV = [this.fileHeaders, ...this.fileRows]

			if (errorColumn == -1)
				newCSV[0].push(this.errorColumnName)

			this.exportToCSV('Materials.csv', newCSV)
		},

		isCategoryValid(categoryPath) {
			/*
			Returns {data: true, id: (categoryId)} if a category path is valid,
			based on this.categories. If invalid, returns {data: false,
			error: (error description)}
			 */

			let subNames = categoryPath.split('\\\\')

			if (!subNames.length) {
				return {result: false, error: "Must provide a category."}
			}

			let subCategories = this.categoryTree
			let subCategory = {id:0, children: []}

			for (let i = 0; i < subNames.length; i++) {
				subCategory = subCategories.find(sub => {
					return (sub.category_id == subCategory.id) && (sub.name == subNames[i])
				})
				if (!subCategory)
					return {result: false, error: "Category '"+subNames[i]+"' does not exist."}

				subCategories = subCategory.children
			}

			if (subCategory.children.length)
				return {result: false, error: "Category '"+subCategory.name+"' contains subcategories."}

			return {result: true, id: subCategory.id}
		},

		validateFile() {
			/*
			Validates the "Category" column in this.fileRows
			If all categories in the file are valid, sends the user to the 'confirm-import'
			page where they may complete the process. If one or more categories in the file
			are invalid, sends the user to the 'categories-summary' page.
			 */

			// { CSV Field : TradeTraks Field }
			let csvToFields = {
				'CategoryID': 'category_id',
				'Description': 'description',
				'Part Number': 'part_number',
				'Supplier PN' : 'supplier_number',
				'Manufacturer' : 'manufacturer',
				'Date of Last Price Update': 'price_updated',
				'Per Unit': 'per',
				'Unit Type': 'material_unit_type',
				'Material Price': 'material_price',
				'Labour': 'labour_hrs',
				'Supplier ID': 'supplier_id'
			}

			this.allMaterials = []
			this.fixableMaterials = []

			let isSomeInvalid = false     // Do some rows contain severe errors that are not category-related?

			// Column containing file errors.  Append to end if doesn't already exist
			let errorColumn = this.fileHeaders.findIndex(col => col == this.errorColumnName)
			if (errorColumn == -1)
				errorColumn = this.fileHeaders.length

			this.fileRows.forEach((row, index) => {
				let categoryPath = row[this.headerIndices['Category']]
				let isCategoryValid = this.isCategoryValid(categoryPath)

				// Generate new material
				let newMaterial = {
					category_id: isCategoryValid.result ? isCategoryValid.id : 0,
					is_draft: !isCategoryValid.result
				}

				Object.keys(this.headerIndices).forEach(header => {
					if (header in csvToFields)
						newMaterial[csvToFields[header]] = row[this.headerIndices[header]]
				})

				// Create a master list of materials to add to TradeTraks.
				let invalid = this.isRowInvalid(newMaterial)

				if (invalid) {

					while (row.length < errorColumn + 1)
						row.push(null)
					row[errorColumn] = invalid

					isSomeInvalid = true

				} else {
					this.allMaterials.push(newMaterial)
				}

				// If the material is FIXABLE (no category set) add it to our fixable list
				if (!isCategoryValid.result) {
					newMaterial.error = isCategoryValid.error
					this.fixableMaterials.push(newMaterial)
				}

			})

			if (isSomeInvalid) {
				this.isErrorAlertVisible = true
			} else if (this.fixableMaterials.length) {
				this.currentStage = 'categories-summary'
			} else {
				this.saveMaterials(this.allMaterials).then(response => {
					if (response.success)
						this.currentStage = 'confirm-import'
				})
			}

		},

		isRowInvalid(material) {
			/*
			If the material is invalid, returns an error message.  If the material is valid, return false
			 */

			let isLabourHoursValid = !isNaN(material.labour_hrs)

			let isMaterialPriceValid = !isNaN(material.material_price)

			let numPer = Number(material.per)
			let isPerValid = Number.isInteger(numPer) && numPer > 0

			let validUnitTypes = ["each", "ft", "m", "yard", "oz", "lb", "ton", "g", "kg", "sq.ft.", "sq.m.", "sq.yd", "lt", "usg"]
			let isUnitTypeValid = validUnitTypes.includes(material.material_unit_type)

			let isPriceUpdatedValid = material.price_updated == "" || this.moment(material.price_updated).isValid()

			let numSupplierID = Number(material.supplier_id)
			let isSupplierIDValid = Number.isInteger(numSupplierID)

			let errorMsg = ""

			if (!isLabourHoursValid)
				errorMsg += "'" + material.labour_hrs +"' is not a valid value for 'Labour' (must be a number).  "

			if (!isMaterialPriceValid)
				errorMsg += "'" + material.material_price +"' is not a valid value for 'Material Price' (must be a number).  "

			if (!isPerValid)
				errorMsg += "'" + material.per +"' is not a valid value for 'Per Unit' (must be a rounded number).  "

			if (!isUnitTypeValid)
				errorMsg += "'" + material.material_unit_type +"' is not a valid value for 'Unit Type'.  "

			if (!isPriceUpdatedValid)
				errorMsg += "'" + material.price_updated +"' is not a valid value for 'Date of Last Price Update' (must be in the format YYYY-MM-DD)."

			if (!isSupplierIDValid)
				errorMsg += "'" + material.supplier_id +"' is not a valid value for 'Supplier ID' (must be a rounded number).  "

			return (errorMsg) ? errorMsg : false
		},

		numAsChar(num) {
			/*
			Converts a number to a character (ex. 0 -> A, 1 -> B...)
			 */
			return (num + 9).toString(36).toUpperCase()
		},

		downloadTemplate() {
			/*
			Download the template.csv file provided in the example
			 */
			this.exportToCSV('template.csv', this.exampleCSV)
		},

		uploadFile(event) {
			/*
			Triggered when a file is uploaded.
			Modifies file, fileHeaders, and fileRows
			 */
			let vm = this

			// Make sure we start with fresh fields
			this.resetImport()

			if (event.target.files.length > 0)
				this.file = event.target.files[0]

			let f = this.file;

			let reader = new FileReader();

			let allowedMimes = [
				"text/plain",
				"text/csv",
				"application/vnd.ms-excel"
			]

			//check file extension type
			if (allowedMimes.indexOf(f.type) == -1)
				vm.alertFail("Invalid file format! File must be a CSV")

			else {

				// Closure to capture the file information.
				reader.onload = (theFile => {
					return e => {

						let csvObj = vm.CSVToArray(e.target.result)

						// Validate that we have at least one data row
						if (csvObj.length == 0) {
							vm.alertFail("File must have at least one data row!")
							return
						}

						vm.fileHeaders = csvObj[0]
						csvObj.splice(0, 1)

						// Remove all completely empty rows
						let removeIndices = []
						csvObj.forEach((row, index) => {
							if (row.every(val => val === ''))
								removeIndices.push(index)
						})

						for (let i = removeIndices.length-1; i >= 0; i--)
							csvObj.splice(removeIndices[i], 1)

						// Check if last row is a blank, if so remove it
						if (csvObj[csvObj.length-1].length == 1)
							csvObj.splice(csvObj.length-1,1)

						// Validate that we have the correct # of columns
						if (vm.fileHeaders.length < vm.requiredFields.length) {
							vm.alertFail("File is missing one or more columns!")
							return
						}

						vm.fileRows = csvObj
						vm.pulledFromCSV = true
					};
				})(f);

				reader.readAsText(f);
			}
		},

		fetchCategories() {
			let vm = this

			this.getJSON("MaterialCategory/get").then(response => {
				if (response.success)
					vm.categories = response.data
			})
		},

		fetchMaterialDrafts() {
			/*
			Fetch stored material drafts from a previous session.
			If stored drafts exist, then go directly to the "Fix File" page.
			If no stored drafts exist, then start on the category tree as usual.
			 */
			let vm = this

			let payload = {
				filters: [ ['is_draft', 1] ],
				limit: 25
			}

			this.getJSON("Material/get", payload).then(response => {
				if (response.success) {

					if (response.data.length > 0) {

						response.data.forEach(mat => {
							mat.category_id = (mat.category_id == '0') ? null : mat.category_id
						})

						vm.allMaterials = response.data
						vm.fixableMaterials = response.data
						vm.pulledFromCSV = false
						vm.categoryKey += 1
						vm.currentStage = 'fix-file'

					} else if (vm.allMaterials.length > 0) {
						vm.currentStage = 'confirm-import'
					}
				}
			})
		},

	},

	created() {

		this.fetchCategories()
		this.fetchMaterialDrafts()
	}
}
</script>

<style scoped>


</style>